export default {
  id: 'SearchResult',
  code: 'CN',
  text: {
    '{ticket_amount}': '{ticket_amount}人',
  }
}



// WEBPACK FOOTER //
// ./src/containers/Main/SearchResult/locale.js